export function addRecipeInfo(elem) {

  const prepTime = elem.querySelector('.recipe-legend-icon__prep-time')
  const cookingTime = elem.querySelector('.recipe-legend-icon__cooking-time')
  const serves = elem.querySelector('.recipe-legend-icon__serves')
  const difficulty = elem.querySelector('.recipe-legend-icon__difficulty')

  const recipeInfo = {
    'prepTime' : prepTime.dataset.info,
    'cookingTime' : cookingTime.dataset.info,
    'serves' : serves.dataset.info,
    'difficulty' : difficulty.dataset.info
  }

  const animatePrepTime = () => {
    //console.log(recipeInfo.prepTime)
  }

  const animateCookingTime = () => {
    //console.log(recipeInfo.cookingTime)
  }

  const animateServes = () => {
    //console.log(recipeInfo.serves)
  }

  const animateDifficulty = () => {
    //console.log(recipeInfo.difficulty)
  }

}


// WEBPACK FOOTER //
// ./src/recipe-info.js